import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { TextLink } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const PackageSwitcherContent = styled(Flex)`
    flex-direction: column;
    padding: 16px 24px;
    gap: 24px;
    border-top: 1px solid ${colorsPalettes.carbon[50]};
`;

export const InfoHolder = styled(Flex)`
    align-items: center;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    background-color: ${colorsPalettes.carbon[25]};
`;

export const SecurePaymentWrapper = styled(Flex)`
    flex-direction: column;
    gap: 4px;
    padding: 16px 0;
    align-items: center;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
`;

export const TextLinkWithoutIcon = styled(TextLink)`
    & svg {
        display: none;
    }
`;
